export default __webpack_public_path__ + "static/media/hazardous.6647e8fa.png";